import { Container } from "components";
import ResetPasswordForm from "./ResetPasswordForm";
export function ResetPasswordContent() {
    return (<Container>
            <ResetPasswordForm />
        </Container>);
}
